import { Box, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import EquipmentReturnWarningIcon from "../../../../assets/icons/EquipmentReturnWarning.svg";
import { FALLBACK_BANNERS } from "../../../../Constants/constants";
import { getBannerMessageByKey } from "../../../../Services/helper";
import {
  HomepageBannerButton,
  HomepageBannerCard,
  HomepageBannersWrapper,
} from "../../../../Styles/GlobalStyles";

const FALLBACK_CONTENT = FALLBACK_BANNERS.ReturnEquipment.content;

export const EquipmentReturnPendingBanner = () => {
  const navigate = useNavigate();
  const sideCoreBannerMessages = useSelector(
    (state: any) => state?.sideCoreContent?.bannerMessages
  );
  const equipmentReturnBannerMessage = getBannerMessageByKey(
    "ReturnEquipment",
    sideCoreBannerMessages
  );
  const content = equipmentReturnBannerMessage?.content ?? FALLBACK_CONTENT;
  const sitecoreIconSrc =
    sideCoreBannerMessages?.ReturnEquipment?.["return-equipment-scenarios"]?.content?.icon?.src;
  const iconSrc = sitecoreIconSrc || content?.icon?.src || EquipmentReturnWarningIcon;

  const heading = content?.heading?.[0]?.text ?? FALLBACK_CONTENT.heading[0].text;
  const subheading =
    content?.subheading?.find((item: any) => item?.type === "text")?.text ??
    FALLBACK_CONTENT.subheading[0].text;
  const buttonText =
    content?.subheading?.find((item: any) => item?.type === "button")?.text ??
    FALLBACK_CONTENT.subheading[1].text;

  return (
    <HomepageBannersWrapper>
      <HomepageBannerCard sx={{ backgroundColor: "#FFF8E6" }}>
        <Stack direction="row" alignItems="center" gap={2} flexGrow={1}>
          <Box
            sx={{
              minWidth: "40px",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: "#FFF0C2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}>
            <Box
              component="img"
              src={iconSrc}
              alt="Equipment return warning"
              sx={{ width: "20px", height: "20px" }}
            />
          </Box>
          <Box>
            <Typography color="#92400E" fontSize={{ xs: "16px", sm: "18px" }} fontWeight={600}>
              {heading}
            </Typography>
            <Typography color="#92400E" fontSize="14px" mt={0.5}>
              {subheading}
            </Typography>
          </Box>
        </Stack>
        <HomepageBannerButton onClick={() => navigate("/account")}>
          {buttonText?.toUpperCase()}
        </HomepageBannerButton>
      </HomepageBannerCard>
    </HomepageBannersWrapper>
  );
};

